import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getSite(id: string) {
    try {
        const response = await apiGet('core', `site-list/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function siteListAdd(body: any) {
    try {
        const response = await apiPost('core', `site-list`, body);
        return response;
    } catch (e) { }
}

export async function siteListUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-list/${id}`, body);
        return response;
    } catch (e) { }
}

export async function siteListRemove(id: any) {
    try {
        return await apiDelete('core', `site-list/${id}`);
    } catch (e) { }
}



export async function siteEmployeeAdd(body: any) {
    try {
        const response = await apiPost('core', `site-employee`, body);
        return response;
    } catch (e) { }
}

export async function siteEmployeeUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-employee/${id}`, body);
        return response;
    } catch (e) { }
}

export async function siteEmployeeRemove(id: any) {
    try {
        return await apiDelete('core', `site-employee/${id}`);
    } catch (e) { }
}

export async function siteSubcontractorAdd(body: any) {
    try {
        const response = await apiPost('core', `site-sub-contractor`, body);
        return response;
    } catch (e) { }
}

export async function siteSubcontractorRemove(id: any) {
    try {
        return await apiDelete('core', `site-sub-contractor/${id}`);
    } catch (e) { }
}



export async function siteEquipmentAdd(body: any) {
    try {
        const response = await apiPost('core', `site-equipment`, body);
        return response;
    } catch (e) { }
}

export async function siteEquipmentUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-equipment/${id}`, body);
        return response;
    } catch (e) { }
}

export async function siteEquipmentRemove(id: any) {
    try {
        return await apiDelete('core', `site-equipment/${id}`);
    } catch (e) { }
}


export async function siteVehicleAdd(body: any) {
    try {
        const response = await apiPost('core', `site-vehicle`, body);
        return response;
    } catch (e) { }
}

export async function siteVehicleUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-vehicle/${id}`, body);
        return response;
    } catch (e) { }
}

export async function siteVehicleRemove(id: any) {
    try {
        return await apiDelete('core', `site-vehicle/${id}`);
    } catch (e) { }
}

export async function siteChemicalAdd(body: any) {
    try {
        const response = await apiPost('core', `site-chemical`, body);
        return response;
    } catch (e) { }
}

export async function siteChemicalUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-chemical/${id}`, body);
        return response;
    } catch (e) { }
}

export async function siteChemicalRemove(id: any) {
    try {
        return await apiDelete('core', `site-chemical/${id}`);
    } catch (e) { }
}


export async function siteSetupEmployeeAdd(body: any) {
    try {
        const response = await apiPost('core', `site-setup`, body);
        return response;
    } catch (e) { }
}